import React, { useEffect, useState } from "react";
import { Button, Modal, Select, Col, Row, Typography, InputNumber } from "antd";
import { TrainingAPI } from "../../api/TrainingAPI";
import moment from "moment";
import { PlanTable } from "./PlanTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setCalendarData } from "../../store/actions/calendar.actions";
import { audioMessage as message } from "../Common/Notifications/audioMessage";

const { Text } = Typography;

const AddPredictionDialog = ({
  open,
  setOpen,
  date_string,
  drills,
  refreshPopup,
}) => {
  const dispatch = useDispatch();
  const { data } = useSelector(({ calendar }) => calendar);
  const [plan, setPlan] = useState([]);
  const [selectedDrill, setSelectedDrill] = useState(undefined);
  const [selectedDuration, setSelectedDuration] = useState(1);
  const [loading, setLoading] = useState(false);

  const {
    metrics: teamMetrics,
    info: teamInfo,
    costPerMin,
  } = useSelector(({ team }) => team);

  const handleSubmitDialog = async () => {
    if (plan.length) {
      setLoading(true)
      try {
        await trainingAPI.addPracticePlan(plan, date_string);
        const response = await trainingAPI.getCostOfDay(date_string);
        dispatch(
          setCalendarData({
            ...data,
            [date_string]: { ...data[date_string], ...response },
          })
        );
        refreshPopup(moment(date_string));
      } catch(error) {
        console.error("Error adding practice plan ", error);
        message.error("Error adding practice plan");
      }
    }
    setLoading(false);
    setOpen(false);
    setSelectedDrill(undefined);
    setSelectedDuration(1);
  };

  const handleAddPlan = (drill_id, duration) => {
    if (drill_id && duration) setPlan([...plan, { drill_id, duration }]);
  };

  const handleRemovePlan = (index) => {
    setPlan(plan.filter((_, i) => i !== index));
  };

  let trainingAPI = new TrainingAPI();

  useEffect(() => {
    if (open === true) {
      // add prediction dialog opened
      trainingAPI.getPracticePlan(date_string, date_string).then((data) => {
        setPlan(data);
      });
    }
    // eslint-disable-next-line
  }, [open]);

  const opponent = data[date_string]?.opponent;

  return (
    <>
      <Modal
        title={
          "Add a Practice Plan for " + moment(date_string).format("MMM Do")
        }
        open={open}
        onOk={handleSubmitDialog}
        confirmLoading={loading}
        width={1000}
        onCancel={() => setOpen(false)}
      >
        <Col>
          {opponent ? (
            <Row style={{ marginBottom: "16px" }}>
              <Col style={{ fontSize: 16, fontWeight: "bold" }}>
                Opponent: {opponent}
              </Col>
            </Row>
          ) : <></>}
          <Row gutter={16}>
            <Col>
              <Text> Drill: </Text>
            </Col>
            <Col span={14}>
              <Select
                showSearch
                notFoundContent="You have no drills. Tag your Training sessions with drills to create smarter Practice Plans and get predictions for your player metrics."
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear
                value={
                  drills?.filter((x) => x.drill_id === selectedDrill)?.[0]
                    ?.name || ""
                }
                style={{ width: "100%" }}
                onChange={(val) => setSelectedDrill(val)}
                options={drills?.map((item) => {
                  return {
                    label: item.name + " ( Latest: " + item.latest_date + " )",
                    value: item.drill_id,
                  };
                })}
              />
            </Col>

            <Col>
              <Text> Duration: </Text>
            </Col>
            <Col span={4}>
              <InputNumber
                min={1}
                value={selectedDuration}
                size={"small"}
                style={{ width: "100%" }}
                onChange={(value) => setSelectedDuration(value)}
              />
            </Col>
            <Col span={2}>
              <Button
                type="primary"
                size={"small"}
                disabled={!(selectedDrill && selectedDuration)}
                onClick={() => handleAddPlan(selectedDrill, selectedDuration)}
              >
                Add to Plan
              </Button>
            </Col>
          </Row>

          <Row style={{ marginTop: "1em" }}>
            <Col span={24}>
              <PlanTable
                plan={plan}
                setPlan={setPlan}
                drills={drills}
                metrics={teamMetrics}
                costPerMin={costPerMin}
                teamInfo={teamInfo}
                handleRemovePlan={handleRemovePlan}
              />
            </Col>
          </Row>
        </Col>
      </Modal>
    </>
  );
};

export default AddPredictionDialog;
